import { Add, More } from "iconsax-reactjs";
import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import AddressItem from "../AddressItem";
import { useTranslation } from "react-i18next";
import { httpReauest } from "../../../utils/httpRequest";

const AddressModal = ({ show, setShow, getData, selectedAddress }) => {
  const { t } = useTranslation();
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);


  useEffect(() => {
    if (show) {
      fetchAddresses();
    }
  }, [show]);

  const fetchAddresses = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return;

    if (selectedAddress) {
      setSelectedAddressId(selectedAddress)
    }

    try {
      const res = await httpReauest("GET", `/user/address/${user._id}`);
      setAddresses(res.data.data); // فرض بر اینه که لیست آدرس‌ها داخل `data` هست
    } catch (error) {
      console.error("خطا در دریافت آدرس‌ها", error);
    }
  };

  const handleSelect = async (addressId) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return;

    try {
      await httpReauest(
        "POST",
        `/user/address`,
        {
          addressId,
          userId: user._id,
        },
        {
          "x-access-token": user.token,
        }
      );
      setSelectedAddressId(addressId);
      getData();
      setShow(false); // بستن پس از انتخاب
    } catch (error) {
      console.error("خطا در انتخاب آدرس", error);
    }
  };
  return (
    <>
      {show && (
        <div
          onClick={() => setShow(false)}
          className="bg-black/50 fixed bottom-0 left-0 w-full right-0  h-full z-40"
        ></div>
      )}
      <div
        className={`${
          show ? "translate-y-0" : "translate-y-full"
        } duration-300 fixed bottom-0 left-0 right-0 max-w-[768px] mx-auto z-[52] bg-white w-full p-4 h-[80vh] rounded-t-[16px] text-[#000]`}
      >
        <div className="flex justify-between items-start">
          <div className="flex gap-2 items-center">
            <FaTimes onClick={() => setShow(false)} />
            {t("select-address")}
          </div>
          <Link
            to={"/profile/add-address"}
            className="text-blue-500 flex gap-1 items-center"
          >
            {t("new-address")}
            <Add />
          </Link>
        </div>
        <div className="grid mt-8 gap-4">
          {addresses.map((item) => (
            <AddressItem
              key={item._id}
              data={item}
              selected={selectedAddressId === item._id}
              onSelect={() => handleSelect(item._id)}
              onDeleteSuccess={() => {
                fetchAddresses();
                getData();
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default AddressModal;
